// src/shared/components/Badges.jsx
import '../../styles/components/badges.css';
import Icon from './Icon';

export function Avatar({ agent, size = 28 }) {
  if (!agent) {
    return (
      <div className="avatar avatar--empty" style={{
        width: size, height: size,
        fontSize: size * 0.4,
      }}>?</div>
    );
  }
  return (
    <div className="avatar avatar--filled" style={{
      width: size, height: size,
      background: `linear-gradient(135deg, hsl(${agent.hue} 70% 60%), hsl(${agent.hue} 70% 45%))`,
      fontSize: size * 0.42,
    }}>{agent.initials}</div>
  );
}

export function CategoryIcon({ icon, color, size = 20, className }) {
  return (
    <span className={`category-icon ${className || ''}`} style={{
      width: size, height: size,
      background: `color-mix(in oklab, ${color || '#9ca3af'} 15%, transparent)`,
      color: color || '#9ca3af',
    }}>
      <Icon name={icon || 'tag'} size={Math.round(size * 0.6)} stroke={2} />
    </span>
  );
}

